module.exports = __webpack_public_path__ + "img/Apoptosis-OPSCC_PMID37704757.c56adf86.png";